// Keeps the viewport where it is when drilling through the catalog tree.
//
// Turbolinks scrolls to the top on every `advance` visit. That is right when
// you navigate somewhere new and wrong when you refine a facet: the sidebar
// entry you just clicked jumps out from under the cursor, and on a deep tree
// you have to scroll back down to continue drilling.
//
// Deliberately scoped to the catalog links only. Sort and pagination still
// scroll to top, which is correct for them — a new ordering or a new page
// should start at its first result.
//
// Scoped to full-page catalog navigation, which after results_swap.js means
// the account asset browser. Both render the same partials/_catalog_sidebar.

const KEY = "assetCatalogScroll"

$(document).on("click", ".asset-browse-catalog-link", function (event) {
  // The public asset pages swap their results in place (results_swap.js), so
  // nothing navigates there and there is no position to carry across. This is
  // for the account browser, whose catalog links are still full page loads.
  if (this.closest("#assets-results")) return

  // A modified click opens a new tab, so no visit follows here and the stash
  // would sit around waiting to be applied to an unrelated load.
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  if (event.which && event.which !== 1) return

  try {
    // Stored against the pathname it was taken on, so a visit that leaves the
    // browse page entirely can't inherit a position from it.
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ path: window.location.pathname, y: window.scrollY })
    )
  } catch {
    // Storage writes can throw with cookies blocked. Landing at the top is an
    // acceptable outcome, so there is nothing to recover from.
  }
})

$(document).on("turbolinks:load", function () {
  let saved = null

  try {
    saved = JSON.parse(sessionStorage.getItem(KEY))
    sessionStorage.removeItem(KEY)
  } catch {
    return
  }

  if (!saved || saved.path !== window.location.pathname) return

  window.scrollTo(0, saved.y)

  // Filtering can shorten the document (a narrower type facet prunes the tree),
  // in which case the scroll above gets clamped. Re-apply once layout settles.
  window.requestAnimationFrame(function () {
    window.scrollTo(0, saved.y)
  })
})
